import { FC } from "react";
import Link from "next/link";

interface FactProps {
  data: any;
}
const ProjectFacts: FC<FactProps> = ({ data }) => {
  return (
    <div className="bg-white border border-gray-700 w-full lg:flex-1 flex flex-col p-4 gap-4">
      <h2 className="border-b border-gray-300 text-lg font-normal">
        Project Facts
      </h2>
      <div className="flex text-sm">
        <h3>
          <b>Developer :&nbsp;</b>
        </h3>
        <Link href={`/newconstruction/builder/${data.developerSlug}`}>
          <a className="text-blue-500">{data.developer}</a>
        </Link>
      </div>
      <div className="flex text-sm">
        <h3>
          <b>Address:&nbsp;</b>
        </h3>
        <p>{data.address || ""}</p>
      </div>
      <div className="flex text-sm">
        <h3>
          <b>Nearest Intersection:&nbsp;</b>
        </h3>
        <p>{data.intersection || ""}</p>
      </div>
      <div className="flex text-sm">
        <h3>
          <b>Pricing:&nbsp;</b>
        </h3>
        <p>
          {data.price
            ? ` Starting from  ${data.price.toLocaleString()}`
            : "TBA"}
        </p>
      </div>
      <div className="flex text-sm">
        <h3>
          <b>Estimated Completion:&nbsp;</b>
        </h3>
        <p>{data.occupancy || ""}</p>
      </div>
      <div className="flex text-sm">
        <h3>
          <b>Square Footage:&nbsp;</b>
        </h3>
        <p>{data.area + " sqft" || ""}</p>
      </div>
      <div className="flex flex-wrap text-sm">
        <p className="break-all text-justify">
          <b>Community Features:&nbsp;</b>
          {data.communityFeatures || ""}
        </p>
      </div>
    </div>
  );
};

export default ProjectFacts;
